module.exports = __webpack_public_path__ + "static/media/2 (26).37c30166.jpg";